import { Trans } from '@lingui/macro'
import { Card, Grid } from '@mui/material'
import { FC, useEffect } from 'react'
import { ContactParsed } from 'app/services/sfAuth/sfData/sfContact'

interface ContactSearchResultCardProps {
  contact: ContactParsed
  onSelect: (contact: ContactParsed) => void
  isSelected: boolean
  isSingleResult: boolean
  sx?: any
}

const ContactSearchResultCard: FC<ContactSearchResultCardProps> = ({
  contact,
  onSelect,
  isSelected,
  isSingleResult,
  sx
}) => {
  useEffect(() => {
    if (isSingleResult) {
      onSelect(contact)
    }
  }, [isSingleResult])
  return (
    <Card
      elevation={6}
      style={{
        padding: 16,
        border: 'none',
        boxShadow: 'none',
        outline: isSelected ? '1px solid #17374F' : '0.25px solid rgba(0, 0, 0, 0.25)'
      }}
      sx={sx}
      onClick={() => onSelect(contact)}
    >
      <Grid container direction='row' wrap='nowrap' alignItems='center'>
        <Grid item container direction='column' style={{ flex: 1 }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              columnGap: 16,
              rowGap: 5,
              fontSize: 14,
              lineHeight: '20px'
            }}
          >
            <b><Trans>First Name</Trans>:</b>
            <div>{contact.firstName}</div>

            <b><Trans>Last name</Trans>:</b>
            <div>{contact.lastName}</div>

            <b><Trans>E-mail</Trans>:</b>
            <div>{contact.email}</div>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

export default ContactSearchResultCard
